import "moment/locale/it"
import { Col, Row } from "react-bootstrap"
import { statNumberToString } from "../../../apis/transform/stats"
import yellowCard from "@assets/images/yellow-card.png"
import redCard from "@assets/images/red-card.png"
import Image from "next/image"

export function PlayerFouls({ yellowCards, redCards }: { yellowCards: number; redCards: number }) {
  return (
    <Col className={"colStats"}>
      <Row>
        <Col sm={6} className={"centerColumn"}>
          <Row>
            <Col>
              <Image src={yellowCard.src} alt={"Ammonizioni"} layout={"intrinsic"} width={22} height={30} />
            </Col>
          </Row>
          <Row>
            <Col className={"competitionSeasonValue"}>{statNumberToString(yellowCards)}</Col>
          </Row>
          <Row>
            <Col className={"competitionSeasonLabel"}>Ammonizioni</Col>
          </Row>
        </Col>
        <Col sm={6} className={"centerColumn"}>
          <Row>
            <Col>
              <Image src={redCard.src} alt={"Espulsioni"} layout={"intrinsic"} width={22} height={30} />
            </Col>
          </Row>
          <Row>
            <Col className={"competitionSeasonValue"}>{statNumberToString(redCards)}</Col>
          </Row>
          <Row>
            <Col className={"competitionSeasonLabel"}>Espulsioni</Col>
          </Row>
        </Col>
      </Row>
    </Col>
  )
}
